import styled from 'styled-components';

export const Container = styled.div``;

interface IBody {
  offsetTop: number;
}

export const Body = styled.div<IBody>`
  --offset-top: ${({ offsetTop }) => offsetTop}px;

  display: grid;
  grid-template-columns: minmax(min-content, 321px) 1fr;
  background: #fff;
  height: calc(100vh - var(--offset-top));
`;

export const Left = styled.div`
  padding: 24px 24px 0 24px;
  border-right: 1px solid #e9edf1;
  height: calc(100vh - var(--offset-top));
`;

export const LeftBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Right = styled.div`
  padding: 24px;
  padding-bottom: 5px;
  height: calc(100vh - var(--offset-top));
`;

export const LeftHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #161a30;

  &.values {
    font-size: 14px;
    font-weight: 600;
    color: #696f8c;
  }

  &.labels {
    font-size: 12px;
    font-weight: 400;
    color: #696f8c;
  }
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const StudioDataDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% + 48px);
  background-color: #f5f7fb;
  padding: 24px;
  align-self: flex-end;
  align-items: center;
  margin-right: -24px;
`;

export const LogoDiv = styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  border: 1px solid #e6e8f0;
  background-color: #fff;
`;

export const Logo = styled.img`
  width: 78px;
  height: 78px;
  border-radius: 8px;
`;

export const TopicsDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const MetricDiv = styled.div`
  display: flex;
  flex-direction: Row;
  align-items: center;
  gap: 5px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
